import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from '@/lib/theme';
import PapersPage from '@/views/PapersPage';
import PaperDetailPage from '@/views/PaperDetailPage';
import RelationshipsPage from '@/views/RelationshipsPage';
import ComparePage from '@/views/ComparePage';
import AboutPage from '@/views/AboutPage';

import '@/styles/global.css';
import './styles/app.css';

const basename = import.meta.env.BASE_URL;

export default function App() {
  return (
    <ThemeProvider>
      <BrowserRouter basename={basename}>
        <Routes>
          <Route path="/" element={<PapersPage />} />
          <Route path="/papers/*" element={<PaperDetailPage />} />
          <Route path="/relationships" element={<RelationshipsPage />} />
          <Route path="/compare" element={<ComparePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
}
